import addDays from 'date-fns/addDays';
import format from 'date-fns/format';
import isValid from 'date-fns/isValid';
import tzFormat from 'date-fns-tz/format';
import utcToZonedTime from 'date-fns-tz/utcToZonedTime';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinus } from '@fortawesome/free-solid-svg-icons';

import {
  FULL_MONTH,
  MONTH_DAY,
  MONTH_DAY_YEAR_HOUR_MINUTE,
  MONTH_DAY_YEAR,
  MONTH_DAY_YEAR_SLASH,
  UTC,
} from '../Constants/DateFormatStrings';

export function formatLocalForAssetDashboardTile(date) {
  return isValid(date) ? format(date, MONTH_DAY_YEAR_HOUR_MINUTE) : '';
}

export function formatLocalMonthDayYear(date_string) {
  const date = new Date(date_string);
  return isValid(date) ? (
    format(date, MONTH_DAY_YEAR_SLASH)
  ) : (
    <FontAwesomeIcon icon={faMinus} />
  );
}

export function formatUTCForAssetDashboardTile(date) {
  return isValid(date)
    ? tzFormat(utcToZonedTime(date, UTC), MONTH_DAY_YEAR, { timeZone: UTC })
    : '';
}

export function formatUTCForWeeklyUtilizationTile(date) {
  return isValid(date)
    ? `${formatUTCMonthDay(date)} - ${formatUTCMonthDay(addDays(date, 6))}`
    : '';
}

export function formatUTCFullMonth(date) {
  return isValid(date)
    ? tzFormat(utcToZonedTime(date, UTC), FULL_MONTH, { timeZone: UTC })
    : '';
}

export function formatUTCMonthDay(date) {
  return isValid(date)
    ? tzFormat(utcToZonedTime(date, UTC), MONTH_DAY, { timeZone: UTC })
    : '';
}
